module.exports = __webpack_public_path__ + "static/img/start.d55fcfd0.jpg";